/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 9.7
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * GlobalSearchApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalSearchResult } from '../model/global-search-result';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     * Perform a unified semantic search across entity types
     * Searches across multiple entity types (exercises, lectures, lecture units, exams, FAQs, channels, courses, posts, answer posts) with a consistent response format. When courseIds is not specified, the search is performed globally across all courses the authenticated user has access to. Per-type access rules are enforced server-side via compound Weaviate filters.
     * @param q Search query; can be empty to retrieve recent items
     * @param types Comma-separated entity type filter (exercise, lecture, lecture_unit, exam, faq, channel, course, post, answer_post) or \&#39;all\&#39;; default \&#39;all\&#39;
     * @param excludeTypes Comma-separated entity types to hide from the results; applied after 'types'
     * @param courseIds Course IDs to restrict the search to one or more courses (OR); inaccessible IDs are ignored
     * @param excludeCourseIds Course IDs to exclude from the search; results in these courses are hidden
     * @param limit Maximum number of results (1–25, default 10)
     */
    globalSearch(q: string, types?: string, excludeTypes?: string, courseIds?: Array<number>, excludeCourseIds?: Array<number>, limit?: number): Observable<Array<GlobalSearchResult>> {
        const queryParams = new URLSearchParams();
        if (q !== undefined && q !== null) {
            queryParams.set('q', String(q));
        }
        if (types !== undefined && types !== null) {
            queryParams.set('types', String(types));
        }
        if (excludeTypes !== undefined && excludeTypes !== null) {
            queryParams.set('excludeTypes', String(excludeTypes));
        }
        if (courseIds !== undefined && courseIds !== null) {
            courseIds.forEach(item => queryParams.append('courseIds', String(item)));
        }
        if (excludeCourseIds !== undefined && excludeCourseIds !== null) {
            excludeCourseIds.forEach(item => queryParams.append('excludeCourseIds', String(item)));
        }
        if (limit !== undefined && limit !== null) {
            queryParams.set('limit', String(limit));
        }
        const queryString = queryParams.toString();
        const url = `${this.basePath}/api/search${queryString ? `?${queryString}` : ''}`;
        return this.http.get<Array<GlobalSearchResult>>(url);
    }

}
